import React, { createContext, useContext, useState, useEffect } from "react";

import { getStorage } from "firebase/storage";

import {
    getAuth,
    signOut,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    onAuthStateChanged,
} from "firebase/auth";
import { initializeApp } from "firebase/app";
import {
    getDatabase,
    set,
    ref,
    update,
    child,
    get,
    push,
    query,
    orderByChild,
    equalTo,
    onValue,
} from "firebase/database";

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
//   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
//   databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
//   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
//   appId: process.env.REACT_APP_FIREBASE_APP_ID,
//   measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
// };
const firebaseConfig = {
    apiKey: "AIzaSyBjt9RmNRuulEGLvVbpetqxCNgP1lOaTJs",
    authDomain: "pkr-space.firebaseapp.com",
    databaseURL: "https://pkr-space-default-rtdb.firebaseio.com",
    projectId: "pkr-space",
    storageBucket: "pkr-space.appspot.com",
    messagingSenderId: "734388078513",
    appId: "1:734388078513:web:5f753a85396f9d3968df90",
    measurementId: "G-T7C5C3KE4P"
};

const firebaseApp = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);

const database = getDatabase(firebaseApp);

export const FirebaseContext = createContext(null);
export const useFirebase = () => useContext(FirebaseContext);

export const FirebaseProvider = (props) => {

    const [isUserLoggedIn, setIsUserLoggedIn] = useState("")

    useEffect(() => {
        onAuthStateChanged(firebaseAuth, (user0) => {
            if (user0) {
                const uid = user0.uid;
                localStorage.setItem('mySpaceUid', uid)
                setIsUserLoggedIn(true)
            } else {
                setIsUserLoggedIn(false)
            }
        });
    }, []);

    const getDataOnce = async (email) => {
        const data = query(
            child(ref(database), "users"),
            orderByChild("email"),
            equalTo(email)
        );
        const snapshot = await get(data);
        let ans = [];
        if (snapshot.exists()) {
            snapshot.forEach((childSnapshot) => {
                ans.push(childSnapshot.val());
            });
        }
        return ans;
    };


    const getUserData = async (key, callback) => {
        const userRef = ref(database, `users/${key}`);
        onValue(userRef, (snapshot) => {
            const data = snapshot.val();
            callback(data);
        });
    }

    const getUsersBio = async (key, callback) => {
        const userRef = ref(database, `bio/${key}`);
        onValue(userRef, (snapshot) => {
            const data = snapshot.val();
            callback(data);
        });
    }

    const getPapers = async (key, callback) => {
        const paperRef = ref(database, `papers/${key}`);
        onValue(paperRef, (snapshot) => {
            const data = snapshot.val();
            callback(data);
        });
    }

    const getPresentations = async (key, callback) => {
        const presentationRef = ref(database, `presentations/${key}`);
        onValue(presentationRef, (snapshot) => {
            const data = snapshot.val();
            callback(data);
        });
    }

    const getVideos = async (key, callback) => {
        const paperRef = ref(database, `videos/${key}`);
        onValue(paperRef, (snapshot) => {
            const data = snapshot.val();
            callback(data);
        });
    }
    // getVideos("cS8oudEyTJYa7XpYdZHCNZte63n2", (data) => { console.log("data") })



    return (
        <FirebaseContext.Provider
            value={{
                getVideos,
                getDataOnce,
                getUserData,
                getPapers,
                getPresentations,
                getUsersBio,
            }}
        >
            {props.children}
        </FirebaseContext.Provider>
    );
};
